import{jsx as o}from"react/jsx-runtime";import{Fonts as e}from"@vds-core/typography";import{calculateRem as i,getOS as t}from"@vds-core/utilities";import{ColorTokens as n}from"@vds-tokens/color";import{LayoutTokens as r}from"@vds-tokens/layout";import{TypographyTokens as a}from"@vds-tokens/typography";import{Component as d}from"react";import s,{keyframes as l,css as p}from"styled-components";import c from"../util/AccordionAnimation.js";const m=r.space["6X"].value,u=r.space["8X"].value,f=l`
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-16px);
  }
`,h=l`
  from {
    transform: translateY(20px);
  }

  to {
    transform: translateY(0px);
  }
`,g=s.div.withConfig({displayName:"ChildWrapper",componentId:"VDS__sc-1izf72a-0"})`
  ${function({$opened:o}){return p`
    transition: padding 330ms linear;
    animation-name: ${o?h:f};
    animation-duration: 330ms;
    animation-delay: 100ms;
    animation-timing-function: linear;
  `}};
`,v=s.div.withConfig({displayName:"StyledAccordionDetail",componentId:"VDS__sc-1izf72a-1"})`
  color: ${function({surface:o}){return"dark"===o?n.elements.primary.ondark.value:n.elements.primary.onlight.value}};
  ${function({viewport:o}){return p`
    font-family: ${function(o){return"mobile"===o?e.VerizonNHGeTX:e.VerizonNHGeDS}(o)};
    font-size: ${i(function(o){return"mobile"===o?a.fontsize.body[12].value:a.fontsize.body[16].value}(o))};
    ${"mobile"!==o&&`\n      letter-spacing: ${i(a.letterspacing.wide.value)};`};
    line-height: ${i(function(o){return"mobile"===o?a.lineheight.body[16].value:a.lineheight.body[20].value}(o))};
  `}}
  word-wrap: break-word;
  overflow-wrap: break-word;
  transition: padding 330ms;
  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: ${i(8)};
    }
  }
  &:active,
  &:hover {
    outline: none;
  }
  ${function({$opened:o,$paddingBottom:e}){return o&&`\n    padding-bottom: ${i(e)};\n    padding-top: 0;\n  `}};
`;class y extends d{constructor(){super(...arguments),this.isIos="ios"===t()}componentDidMount(){const{groupId:o}=this.props;this.accordionDetailId=`accordionDetail_${o}`,this.accordionAliasId=`accordionHeaderLabel_${o}`}render(){const{opened:e,children:i,surface:t,viewport:n}=this.props,r="mobile"===n,a=e?"auto":0;return o(v,{viewport:n,$opened:e,surface:t,id:this.accordionDetailId,"aria-labelledby":this.accordionAliasId,tabIndex:this.isIos||e?void 0:-1,role:"region","aria-hidden":!e&&!this.isIos,$paddingBottom:r?m:u,children:o(c,{height:a,opened:e,children:o(g,{$opened:e,children:i})})})}}y.componentType="AccordionDetail",y.defaultProps={opened:!1,surface:"light",groupId:null,viewport:"desktop"},y.componentType="AccordionDetail";export{y as default};
